import {ReactNode} from "react";

interface HeroBannerSlotProps {
    children: ReactNode;
}

/**
 * In-flow counterpart of {@link BannerStack}. Banners placed here are part of
 * the document flow: they run the full width of the content area and push the
 * page down instead of floating over it, which is what `prominence="hero"`
 * banners are for. Render it at the top of the content column, above the page
 * header.
 */
export function HeroBannerSlot({children}: HeroBannerSlotProps) {
    return (
        <div className="flex flex-col">
            {children}
        </div>
    );
}
